var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongLiebiao(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 3.5h9M5 8h9m-9 4.5h9",
    stroke: "#3F465C",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 3.5a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM3 8a.75.75 0 11-1.5 0A.75.75 0 013 8zM3 12.5a.75.75 0 11-1.5 0 .75.75 0 011.5 0z",
    fill: "#3F465C"
  })));
}
export default __webpack_public_path__ + "static/tongyong_liebiao.f299a996.svg";
export { SvgTongyongLiebiao as ReactComponent };